'use strict';

// TODO; semver-major: remove

module.exports = require('call-bind/callBound');



//////////////////
// WEBPACK FOOTER
// ./node_modules/es-abstract/helpers/callBound.js
// module id = 201
// module chunks = 31